<template>
  <v-select
    id="solution-select"
    v-model="solucaoId"
    item-text="nome"
    item-name="solucaoId"
    item-value="solucaoId"
    :items="solutions"
    :label="`${isAT ? 'Iniciativas' : 'Soluções'}`"
    placeholder="Solução"
    clearable
    :multiple="multiple"
    @change="$emit('changeSolution', solucaoId)"
  >
    <template slot="no-data">
      Nenhuma {{ isAT ? "Iniciativa" : "Solução" }} retornada
    </template>
  </v-select>
</template>

<script>
import { solutionAPI } from "@/modules/solution";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSolutionCombobox",
  props: ["filter", "multiple", "filterSolutions", "solutionIds"],
  data() {
    return {
      solutions: [],
      solucaoId: null,
    };
  },
  methods: {
    loadSolutions() {
      solutionAPI.list({}).then((res) => {
        this.solutions = res.data;
      });
    },
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  watch: {
    filterSolutions: {
      handler(val, oldVal) {
        if (val && val.length) {
          this.solutions = val;
        }
      },
      deep: true,
    },
    solutionIds: function (val) {
      this.solucaoId = val;
    },
    filter: {
      handler(val, oldVal) {
        this.solucaoId = val.solucaoId;
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.filter.solutions) {
      this.loadSolutions();
    } else {
      this.solutions = this.filter.solutions;
    }

    this.solucaoId = this.solutionIds;
  },
};
</script>
